import { Component, OnInit } from '@angular/core';
import { ImportExportCodesService } from '../../services/ImportExportCodes.service';
import { HttpEventType, HttpErrorResponse } from '@angular/common/http';
import { HaEditIcdModal } from '../../models/HaEditIcd.model';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { ErrorModel } from '../../../../shared/models/Error.model';

declare var $: any;
@Component({
  selector: 'app-ha-casecodecreation',
  templateUrl: './ha-casecodecreation.component.html',
  styleUrls: ['./ha-casecodecreation.component.css']
})

export class HaCasecodecreationComponent implements OnInit {
  title;
  nodes;
  nodeName;
  showProgress: boolean = false;
  showAlert: boolean;
  showOverlayImportIcd: boolean;
  changeEdit: boolean = false;
  loadingExcelPercentage;
  icdData: HaEditIcdModal[];
  categorySelected: string = '';
  id: number;
  Name: string;
  category: string;
  description: string;
  isEditable: boolean;
  helpText: string;
  searchTerm: string = '';
  searchTermIcd: string = '';
  sendModifiedData: HaEditIcdModal;
  sendAddData: HaEditIcdModal;
  nameFieldData: string = '';
  descriptionFieldData: string = '';
  categoryFieldData: string = '';
  helpTextFieldData: string = '';
  config: object;
  dataModel: any;
  selectData:any;
  mainViewError = new ErrorModel();
  icdError = new ErrorModel();

  constructor(private _service: ImportExportCodesService) {}

  ngOnInit() {
    this.icdData = [];
    this.config = {
      displayKey: 'name', //if objects array passed which key to be displayed defaults to description
      search: true, //true/false for the search functionlity defaults to false,
      height: '150px', //height of the list so that if there are more no of items it can show a scroll defaults to auto. With auto height scroll will never appear
      placeholder: 'Select', // text to be displayed when no item is selected defaults to Select,
      customComparator: () => {}, // a custom function using which user wants to sort the items. default is undefined and Array.sort() will be used in that case,
      limitTo: this.icdData.length, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
      moreText: 'more', // text to be displayed whenmore than one items are selected like Option 1 + 5 more
      noResultsFound: 'No results found!', // text to be displayed when no items are found while searching
      searchPlaceholder: 'Search Category', // label thats displayed in search input,
      searchOnKey: 'name' // key on which search should be performed this will be selective search. if undefined this will be extensive search on all keys
    }
    // this.showOverlayImportIcd = true;
    this.title = 'Angular tree like structure';
    this.importData();
  }

  importData() {
    this.showOverlayImportIcd = true;
    this.mainViewError.display = false;
    this._service.getIcdTree().subscribe((data) => {
      this.nodes = data;
    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;
    }).add(() => {
      this.showOverlayImportIcd = false;
    });
  }

  displayNode(event) {
    this.nodeName = event;
  }

  arrayBuffer: any;
  file: File;
    incomingFile(event) {
      
    this.file = event.target.files[0];
  }

  uploadExcel() {
    this.showProgress = true;
    if (this.file == undefined || this.file == null) {
      this.showProgress = false;
      AlertMessages.Show('WARNING', 'Please choose an Excel file ( .xls ) to upload', AlertType.Warning);
    } else if (this.file.name.search(/.xls|.bmp /g) == -1) {
      AlertMessages.Show('WARNING', 'Please choose an Excel file ( .xls ) to upload', AlertType.Warning);
    } else {
      this._service.uploadIcdExcel(this.file).subscribe((event) => {
        if (event.type == HttpEventType.UploadProgress) {
          this.loadingExcelPercentage = Math.round((event.loaded / event.total) * 100);
        } else if (event.type == HttpEventType.Response) {
          AlertMessages.Show('Uploaded', 'Icd Excel Uploaded', AlertType.Add);
          this.alertClose();
          $('#uploadicd').modal('hide');
        }
      }, (error: HttpErrorResponse) => {
        AlertMessages.Show('Failed', 'Could not upload Sheet!', AlertType.Error);
      }).add(() => {
        this.showProgress = false;

      });
    }
  }

  alertClose() {
    setTimeout(() => {
      this.showAlert = false;
      this.importData();
    }, 2000);
  }

  changeDiv() {
    this.changeEdit = true;
    this.showOverlayImportIcd = true;
    this._service.getIcdAllData().subscribe((data: HaEditIcdModal[]) => {
      this.icdData = data;
      this.getSelectBoxData();
    },
    (error) => {
      this.changeEdit = false;
      AlertMessages.Show('Failed', 'Could not load Data!', AlertType.Error);
    }).add(() => {
      this.showOverlayImportIcd = false;
    });
  }

  getSelectBoxData() {
    this.icdError.display = false;
    this._service.getAllIcdNames().subscribe(
    (data) => {
      this.selectData = data;
    },
    (error) => {
      AlertMessages.Show('Failed', 'Could not load data!', AlertType.Error);
      this.icdError.error = error;
      this.icdError.display = true;
    });
  }

  changeShow() {
    this.changeEdit = false;
    this.importData();
  }

  selectionChanged(event) {

    if (event['value'] !== undefined) {
      if(event['value'].name != null) {
        this.categorySelected = event['value'].name;
      }
    } else {
      this.categorySelected = '';
    }
  }

  editIcd(id, idd, name, category, description, helpText) {
    this.sendModifiedData = new HaEditIcdModal();
    if (name == '' || name == null || name == undefined) {
      AlertMessages.Show('Warning', 'Name field cannot be empty!!!', AlertType.Warning);
    } else {
      let index = this.icdData.findIndex(code => code.id == id);
      this.icdData[index].id = id;
      this.icdData[index].name = name;
      this.icdData[index].category = category;
      this.icdData[index].description = description;
      this.icdData[index].helpText = helpText;
      this.icdData[index].isEditable = false;
      this.sendModifiedData.id = id;
      this.sendModifiedData.name = name;
      this.sendModifiedData.category = category;
      this.sendModifiedData.description = description;
      this.sendModifiedData.helpText = helpText;
      this.sendModifiedData.isEditable = false;
      this._service.updateIcdData(this.sendModifiedData).subscribe(
      (data) => {
        this.sendModifiedData = new HaEditIcdModal();
        AlertMessages.Show('Success', 'Icd Code Updated', AlertType.Success);
      },
      (error) => {
        AlertMessages.Show('Failed', 'Could not update!', AlertType.Error);

      });
    }
  }

  saveIcdNew(formData) {
    this.sendAddData = new HaEditIcdModal();
    if (formData.name == '' || formData.name == null || formData.name == undefined) {
      AlertMessages.Show('Warning', 'Please Enter Name', AlertType.Warning);
    } else {
      this.sendAddData.name = formData.name;
      this.sendAddData.category = this.categorySelected;
      this.sendAddData.description = formData.description;
      this.sendAddData.helpText = formData.note;
      this.sendAddData.isEditable = false;
      this._service.insertIcdData(this.sendAddData).subscribe(
      (data: HaEditIcdModal) => {
        AlertMessages.Show('Added', 'Icd Code Added.', AlertType.Add);
        this.icdData.splice(0, 0, data);
        this.nameFieldData = '';
        this.descriptionFieldData = '';
        this.categoryFieldData = '';
        this.helpTextFieldData = '';
        this.dataModel = '';
      },
      (error) => {
        AlertMessages.Show('Failed', 'Code Not inserted', AlertType.Error);
      });
    }
  }
}
